import { createContext, useContext, useEffect, useState } from 'react';
import { getModulePrivileges } from '../api/module-privilegeAPI';

// Context to store module privileges globally
const ModulePrivilegesContext = createContext([]);

export const ModuleProvider = ({ children }) => {
  const [modules, setModules] = useState([]);

  useEffect(() => {
    const fetchModules = async () => {
      try {
        const data = await getModulePrivileges();
        setModules(data);
      } catch (err) {
        console.error('Failed to load module privileges', err);
      }
    };

    fetchModules();
  }, []);

  return (
    <ModulePrivilegesContext.Provider value={modules}>
      {children}
    </ModulePrivilegesContext.Provider>
  );
};

// Hook to determine if a module is enabled
export const useModule = (moduleName) => {
  const modules = useContext(ModulePrivilegesContext);
  if (!moduleName) return false;
  const found = modules.find(m => m.module === moduleName);
  return !!(found && found.enabled);
};

